module.exports = __webpack_public_path__ + "img/hunt.03891f8f.png";